import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/software-app-development/banner-back.webp";
import Contactupdatedform from "../../components/contactupdatedform";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service banner-contact lp-software-banner lp-software-app overflow-x-hidden"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#000",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="lead_orange">
              <span>Take The Lead With</span>
            </div>
            <div className="banenr_content">
              <h1 className="software-head-h1" style={{ marginBottom: "10px" }}>
                Award-Winning Mobile Application and{" "}
                <strong>Custom Software Development</strong> Company
              </h1>
              <p>
                Partnering with startups and businesses to deliver cutting-edge
                mobile apps and custom software solutions that inspire growth.
              </p>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <Contactupdatedform />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="featured-main-logo">
              <div className="featured-flex">
                <h5>Featured In</h5>
                <span></span>
                <ul>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/inc-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={94}
                      height={34}
                    />
                  </li>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/forbes-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={114}
                      height={34}
                    />
                  </li>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/yec-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={64}
                      height={34}
                    />
                  </li>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/entrepreneur-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={180}
                      height={34}
                    />
                  </li>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/yahoo-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={115}
                      height={34}
                    />
                  </li>
                  <li>
                    <StaticImage
                      src="../../../images/landing/software-app-development/feature-logo/cms-logo.webp"
                      alt="TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={157}
                      height={31}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
